import { createContext, useContext } from "react";

export const AsyncDataGridPresetsContext = createContext(null);

/**
 * @returns {Object|null}
 */
export function useAsyncDataGridPresets() {
  return useContext(AsyncDataGridPresetsContext);
}
